import { editorPicks } from "@/mocks/content";

export default function EditorPicksSection() {
  return (
    <section id="editors" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div>
          <span className="font-label text-sm font-medium text-primary-600">编辑私心推荐</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            编辑部精选 · 值得认真看完的三部
          </h2>
          <p className="mt-3 max-w-2xl font-body text-sm leading-relaxed text-foreground-600">
            不追热度、只看质量。下面三部是我们反复讨论后，认为最能把韩剧擅长的“情绪”讲到位、值得你腾出整晚去看的作品。
          </p>
        </div>

        <div className="mt-10 space-y-6">
          {editorPicks.map((pick, index) => (
            <article
              key={pick.id}
              className={`flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100/50 lg:flex-row ${
                index % 2 === 1 ? "lg:flex-row-reverse" : ""
              }`}
            >
              <div className="h-56 w-full shrink-0 overflow-hidden lg:h-auto lg:w-1/2">
                <img
                  src={pick.image}
                  alt={`${pick.headline} 剧集场景`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="flex flex-1 flex-col justify-center gap-4 p-6 md:p-8">
                <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 font-label text-xs text-accent-900">
                  <i className="ri-bookmark-3-line" aria-hidden="true"></i>
                  编辑推荐 · 0{index + 1}
                </span>
                <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  {pick.headline}
                </h3>
                <p className="font-body text-sm leading-relaxed text-foreground-700">{pick.blurb}</p>
                <div className="flex flex-wrap items-center gap-3">
                  <span className="inline-flex items-center gap-1 font-label text-sm text-secondary-800">
                    <i className="ri-eye-line" aria-hidden="true"></i>
                    站内长期高分
                  </span>
                  <span className="inline-flex items-center gap-1 font-label text-sm text-foreground-500">
                    <i className="ri-movie-2-line" aria-hidden="true"></i>
                    完整剧集可看
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}